import React from 'react';
import SvgIcon from './SvgIcon';

const EmailFull = props => (
    <SvgIcon viewBox="0 0 24 24" {...props}>
        <path
            d="M.75 19.5l7.5-7.65M.75 4.5L12 15.375 23.25 4.5H.75zm15 7.35l7.5 7.65-7.5-7.65z"
            stroke="currentColor"
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M.75 4.5h22.5v15H.75v-15z"
            stroke="currentColor"
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </SvgIcon>
);

EmailFull.displayName = 'EmailFullIcon';

export default EmailFull;
